import RoamingTimezone from '../store/schema/RoamingTimezone';
import getRegionalOptions from '../store/store';
import { mutatorAction } from 'satcheljs';

export const addEmptyRoamingTimezone = mutatorAction('addEmptyRoamingTimezone', () => {
    const optionState = getRegionalOptions();
    optionState.roamingTimezones.push({
        timezoneId: undefined,
        timezoneLabel: undefined,
    });
});

export const removeRoamingTimezone = mutatorAction('removeRoamingTimezone', (index: number) => {
    const optionState = getRegionalOptions();
    const roamingTimezones = optionState.roamingTimezones;

    roamingTimezones.splice(index, 1);
});

export const setRoamingTimezones = mutatorAction(
    'setRoamingTimezones',
    (roamingTimezones: RoamingTimezone[]) => {
        const regionalOptions = getRegionalOptions();
        regionalOptions.roamingTimezones = roamingTimezones;
    }
);

export const updateRoamingTimezoneId = mutatorAction(
    'updateRoamingTimezoneId',
    (index: number, timezoneId: string) => {
        const optionState = getRegionalOptions();
        const roamingTimezones = optionState.roamingTimezones;

        roamingTimezones[index].timezoneId = timezoneId;
    }
);

export const updateRoamingTimezoneLabel = mutatorAction(
    'updateRoamingTimezoneLabel',
    (index: number, timezoneLabel: string) => {
        const optionState = getRegionalOptions();
        const roamingTimezones = optionState.roamingTimezones;

        roamingTimezones[index].timezoneLabel = timezoneLabel;
    }
);

export const moveUpRoamingTimezone = mutatorAction('moveUpRoamingTimezone', (index: number) => {
    if (index == 0) {
        return;
    }

    const optionState = getRegionalOptions();
    const roamingTimezones = optionState.roamingTimezones;
    const timezoneToMove = roamingTimezones[index];

    roamingTimezones.splice(index, 1);
    roamingTimezones.splice(index - 1, 0, timezoneToMove);
});

export const moveDownRoamingTimezone = mutatorAction('moveDownRoamingTimezone', (index: number) => {
    const optionState = getRegionalOptions();
    const roamingTimezones = optionState.roamingTimezones;

    if (index == roamingTimezones.length - 1) {
        return;
    }

    const timezoneToMove = roamingTimezones[index];

    roamingTimezones.splice(index, 1);
    roamingTimezones.splice(index + 1, 0, timezoneToMove);
});
